<template>
  <div class="lender-archive-container">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>

    <div class="active-offers-container loans-container">
      <div class="active-offers-title">
        {{ $t('message.profile.borrower.activeOffers.title') }}
      </div>
      <div class="filters-block" @keyup.enter="setLoansFilter()">
        <div class="filter-block">
          <base-select
            :key="loansFilterSelectKey"
            :placeholder="$t('message.profile.lender.loans.filter.status')"
            :default-value="loansFilterStatus"
            :dictionary-path="'message.profile.lender.loans.archiveFilterStatus.list.'"
            :options-list="['canceled', 'repaid']"
            v-model="loansFilterStatus"
          />
        </div>
        <div class="filter-block">
          <input
            type="text"
            class="filter-input"
            v-model="loansFilter.full_name_borrower"
            :placeholder="$t('message.profile.lender.loans.filter.borrower')"
          >
        </div>
        <div class="datepicker-block">
          <base-datepicker
            v-model="loansFilter.receipt_date"
            :default-value="loansFilter.receipt_date"
            :format="'DD.MM.YYYY'"
            :range="true"
            :placeholder="$t('message.profile.lender.loans.filter.issued')"
          />
        </div>
        <div class="datepicker-block">
          <base-datepicker
            v-model="loansFilter.due_date"
            :default-value="loansFilter.due_date"
            :format="'DD.MM.YYYY'"
            :range="true"
            :placeholder="$t('message.profile.lender.loans.filter.repaid')"
          />
        </div>
        <div class="datepicker-block">
          <base-datepicker
            v-model="loansFilter.repaid_date"
            :default-value="loansFilter.repaid_date"
            :format="'DD.MM.YYYY'"
            :range="true"
            :placeholder="$t('message.profile.lender.loans.filter.repaidDate')"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.loans.filter.apply')"
            :min-height="'36px'"
            @click="setLoansFilter()"
          />
        </div>
        <div class="button-block">
          <base-button
            class="reset-filter-btn"
            :text="$t('message.profile.lender.loans.filter.reset')"
            :min-height="'36px'"
            @click="resetLoansFilter()"
          />
        </div>
      </div>
      <div class="loans-scroll-content">
        <div class="offers-item-header">
          <div class="agreement">№ договора</div>
          <div class="name">Заемщик</div>
          <div class="rating">Рейтинг</div>
          <div class="issued">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</div>
          <div class="amount">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
          <div class="term">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
          <div class="percent">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
          <div class="income">{{ $t('message.profile.borrower.activeOffers.items.income') }}</div>
          <div class="issued-by">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</div>
          <div class="repaid-date">{{ $t('message.profile.borrower.activeOffers.items.repaidDate') }}</div>
          <div class="peni">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
          <div class="total-amount">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</div>
          <div class="status">{{ $t('message.profile.borrower.activeOffers.items.status') }}</div>
        </div>
        <lender-loan-item
          v-for="item of archivedLoansList"
          :key="item.id"
          :item="item"
          :is-archive="true"
          @openTransactions="openLoanDetails"
        />
        <div v-if="isLoansListEmpty" class="empty-list">{{ $t('message.profile.borrower.activeOffers.noData') }}</div>
      </div>
      <div class="table-footer">
        <div class="notice">* - без учёта комиссий</div>
        <div v-if="loansPagesCounter > 0" class="pagination-block">
          <pagination
            :prevButtonPlaceholder="'<'"
            :nextButtonPlaceholder="'>'"
            :current-page="loansParams.page"
            :pages-count="loansPagesCounter"
            :total-count="archivedLoansCount"
            :page-size="loansParams.size"
            @choice="setLoansPage"
          />
        </div>
      </div>
    </div>

    <div class="active-offers-container offers-container">
      <div class="active-offers-title">
        {{ $t('message.profile.lender.activeOffers.title') }}
      </div>
      <div class="filters-block" @keyup.enter="setOffersFilter()">
        <div class="filter-block">
          <base-select
            :key="offersFilterSelectKey"
            :placeholder="$t('message.profile.lender.loans.filter.status')"
            :default-value="offersFilterStatus"
            :dictionary-path="'message.profile.lender.activeOffers.published.'"
            :options-list="['archive', 'processed', 'blocked']"
            v-model="offersFilterStatus"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.loans.filter.apply')"
            :min-height="'36px'"
            @click="setOffersFilter()"
          />
        </div>
        <div class="button-block">
          <base-button
            class="reset-filter-btn"
            :text="$t('message.profile.lender.loans.filter.reset')"
            :min-height="'36px'"
            @click="resetOffersFilter()"
          />
        </div>
      </div>
      <div class="offers-item-header">
        <div class="amount">{{ $t('message.profile.lender.activeOffers.items.amount') }}</div>
        <div class="term">{{ $t('message.profile.lender.activeOffers.items.term') }}</div>
        <div class="percent">{{ $t('message.profile.lender.activeOffers.items.percent') }}</div>
        <div class="income">{{ $t('message.profile.lender.activeOffers.items.income') }}</div>
        <div class="rating">{{ $t('message.profile.lender.activeOffers.items.rating') }}</div>
        <div class="count">{{ $t('message.profile.lender.activeOffers.items.count') }}</div>
        <div class="status">{{ $t('message.profile.lender.activeOffers.items.status') }}</div>
        <div class="menu"></div>
      </div>
      <lender-offer-item
        v-for="item of archivedOffersList"
        :key="item.public_id || item.createdAt"
        :item="item"
        :readonly="true"
      />
      <div v-if="isOffersListEmpty" class="empty-list">{{ $t('message.profile.lender.activeOffers.noData') }}</div>
      <div class="table-footer">
        <div class="notice">* - без учёта комиссий</div>
        <div v-if="offersPagesCounter > 0" class="pagination-block">
          <pagination
            :prevButtonPlaceholder="'<'"
            :nextButtonPlaceholder="'>'"
            :current-page="offersParams.page"
            :pages-count="offersPagesCounter"
            :total-count="archivedOffersCount"
            :page-size="offersParams.size"
            @choice="setOffersPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import lenderOfferItem from '../Profile/lenderOfferItem.vue';
import lenderLoanItem from '../Profile/lenderLoanItem.vue';
import Pagination from '../../components/common/Pagination.vue';
import BaseSelect from '../../components/base/BaseSelect.vue';
import BaseDatepicker from '../../components/base/BaseDatepicker.vue';
import BaseButton from '../../components/base/BaseButton.vue';

export default {
  name: 'LenderArchive',
  components: {
    lenderOfferItem,
    lenderLoanItem,
    Pagination,
    BaseSelect,
    BaseDatepicker,
    BaseButton
  },
  data() {
    return {
      offersParams: {
        page: 0,
        size: 10
      },
      offersFilter: {
        status: undefined
      },
      offersFilterStatus: '',
      offersFilterSelectKey: 0,
      loansParams: {
        page: 0,
        size: 10
      },
      loansFilter: {
        full_name_borrower: undefined,
        receipt_date: undefined,
        due_date: undefined,
        repaid_date: undefined,
        status: undefined
      },
      loansFilterStatus: '',
      loansFilterSelectKey: 0
    };
  },
  created() {
    this.restoreLoansState();
  },
  methods: {
    restoreLoansState() {
      const { loansParams, loansFilter, loansFilterStatus } = this.$route.params || {};

      if (!loansParams && !loansFilter && !loansFilterStatus) {
        return;
      }

      this.loansParams = {
        ...this.loansParams,
        ...(loansParams || {})
      };
      this.loansFilter = {
        ...this.loansFilter,
        ...(loansFilter || {})
      };

      if (loansFilterStatus) {
        this.loansFilterStatus = loansFilterStatus;
        this.loansFilterSelectKey += 1;
      } else {
        this.loansFilterStatus = '';
      }
    },
    getLoansBackRouteParams() {
      return {
        loansParams: {
          ...this.loansParams
        },
        loansFilter: {
          ...this.loansFilter
        },
        loansFilterStatus: this.loansFilterStatus
      };
    },
    openLoanDetails(id) {
      const item = this.archivedLoansList.find((loan) => loan.public_id === id);

      if (item?.status !== 'repaid') {
        return;
      }

      this.$router.push({
        name: 'loan',
        params: {
          id,
          backRouteName: 'archive',
          backRouteParams: this.getLoansBackRouteParams()
        }
      });
    },
    getLoansRequestParams() {
      return {
        ...this.loansParams,
        filter: this.loansFilter
      };
    },
    async fetchLoansList() {
      this.$store.dispatch('loading', true);

      try {
        await this.$store.dispatch('getLoansArchivedList', this.getLoansRequestParams());
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async setLoansFilter() {
      this.loansParams.page = 0;
      await this.fetchLoansList();
    },
    async resetLoansFilter() {
      this.loansParams.page = 0;
      this.loansFilterStatus = '';
      this.loansFilterSelectKey += 1;
      this.loansFilter = {
        full_name_borrower: undefined,
        receipt_date: undefined,
        due_date: undefined,
        repaid_date: undefined,
        status: undefined
      };
      await this.fetchLoansList();
    },
    async setLoansPage(page) {
      this.loansParams.page = page;
      await this.fetchLoansList();
    },
    getOffersRequestParams() {
      return {
        ...this.offersParams,
        filter: this.offersFilter
      };
    },
    async fetchOffersList() {
      this.$store.dispatch('loading', true);

      try {
        await this.$store.dispatch('getOffersArchivedList', this.getOffersRequestParams());
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async setOffersFilter() {
      this.offersParams.page = 0;
      await this.fetchOffersList();
    },
    async resetOffersFilter() {
      this.offersParams.page = 0;
      this.offersFilterStatus = '';
      this.offersFilterSelectKey += 1;
      this.offersFilter = {
        status: undefined
      };
      await this.fetchOffersList();
    },
    async setOffersPage(page) {
      this.offersParams.page = page;
      await this.fetchOffersList();
    }
  },
  computed: {
    ...mapGetters(['archivedLoansList', 'archivedLoansCount', 'archivedOffersList', 'archivedOffersCount']),
    isOffersListEmpty() {
      return this.archivedOffersList.length === 0;
    },
    isLoansListEmpty() {
      return this.archivedLoansList.length === 0;
    },
    loansPagesCounter() {
      return Math.ceil(this.archivedLoansCount / this.loansParams.size);
    },
    offersPagesCounter() {
      return Math.ceil(this.archivedOffersCount / this.offersParams.size);
    }
  },
  watch: {
    loansFilterStatus(value) {
      if (value) {
        this.loansFilter.status = value;
      } else {
        this.loansFilter.status = undefined;
      }
    },
    offersFilterStatus(value) {
      if (value) {
        this.offersFilter.status = value;
      } else {
        this.offersFilter.status = undefined;
      }
    },
    'loansFilter.receipt_date'(value) {
      if (value && value[0] === null) {
        this.loansFilter.receipt_date = undefined;
      }
    },
    'loansFilter.due_date'(value) {
      if (value && value[0] === null) {
        this.loansFilter.due_date = undefined;
      }
    },
    'loansFilter.repaid_date'(value) {
      if (value && value[0] === null) {
        this.loansFilter.repaid_date = undefined;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lender-archive-container {
  @include base-page-container;

  flex-direction: column;
  color: #121212;
}

.route-name {
  @include route-name;
}

.active-offers-container {
  @include active-offers-container;

  margin-top: 40px;
}

.loans-container.active-offers-container {
  margin-top: 24px;
}

.active-offers-title {
  @include active-offers-title;
}

.offers-item-header {
  @include offers-item-header;
}

.amount {
  width: 10%;
  margin-right: 2%;
}

.term {
  width: 11%;
  margin-right: 2%;
}

.percent {
  width: 10%;
  margin-right: 2%;
}

.income {
  width: 9%;
  margin-right: 2%;
}

.rating {
  width: 7%;
  margin-right: 2%;
}

.count {
  width: 10%;
  margin-right: 2%;
}

.status {
  width: 10%;
  margin-right: 2%;
}

.menu {
  width: 6%;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.loans-container {
  @include loan-item-header;

  min-width: auto;
  overflow-x: auto;

  .repaid-date {
    width: 117px;
    margin-right: 2px;
  }
}

.filters-block {
  width: 100%;
  min-height: 36px;
  display: flex;
  flex-wrap: balance;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 16px;

  .filter-block {
    width: 190px;
    height: 36px;

    ::v-deep .input-wrapper {
      margin-bottom: 0;
      height: 100%;
    }

    ::v-deep .select-block {
      height: 36px;
    }

    ::v-deep .error-block {
      display: none;
    }
  }

  .button-block {
    width: 125px;
    height: 36px;
    margin-top: 0;

    ::v-deep .button {
      min-height: 36px;
      max-height: 36px;
      height: 36px;
      padding: 0 12px;
      border-radius: 6px;
    }
  }

  .reset-filter-btn {
    @include secondary-btn;
  }

  .datepicker-block {
    width: 230px;
    height: 36px;

    ::v-deep .mx-datepicker {
      width: 100%;
      height: 36px;
    }

    ::v-deep .mx-input-wrapper {
      height: 36px;
    }

    ::v-deep .mx-input {
      height: 36px;
    }
  }

  .filter-input {
    padding: 0 10px;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #CDCDCD;
    outline: none;

    &:active {
      border: 1px solid #DCDCDC;
    }
  }
}

.loans-scroll-content {
  min-width: 1220px;
}

.table-footer {
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pagination-block {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
}

.notice {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
}

.empty-list {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  box-sizing: border-box;
}

@media screen and (max-width: 850px) {
  .loans-container .filters-block,
  .offers-container .filters-block {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 12px;

    .filter-block,
    .datepicker-block,
    .button-block {
      width: 100%;
    }

    .button-block ::v-deep .button {
      width: 100%;
      max-width: 100%;
    }
  }

  .loans-container .offers-item-header,
  .offers-item-header {
    display: none;
  }

  .loans-container .loans-scroll-content {
    min-width: auto;
  }

  .active-offers-container {
    min-width: auto;
  }
}
</style>
